import React from "react";
import { Backdrop } from "@mui/material";
import CustomProgress from "../../Components/CustomProgress";

type GlobalBackdropProps = {
  open: boolean;
};

const GlobalBackdrop: React.FC<GlobalBackdropProps> = ({ open }) => {
 

  return (
    <Backdrop
      style={{ color: "#fff", zIndex: 9999999, width: "100%" }}
      open={open}
    >
      <CustomProgress
        sx={{
          height: "50px !important",
          width: "50px !important",
          color: "white",
        }}
      />
    </Backdrop>
  );
};

// ✅ Child will only re-render when `open` changes
export default React.memo(GlobalBackdrop);
